import { render, staticRenderFns } from "./EstadisticasEquipoComponent.vue?vue&type=template&id=1a15e832&scoped=true"
import script from "./EstadisticasEquipoComponent.vue?vue&type=script&lang=js"
export * from "./EstadisticasEquipoComponent.vue?vue&type=script&lang=js"
import style0 from "./EstadisticasEquipoComponent.vue?vue&type=style&index=0&id=1a15e832&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a15e832",
  null
  
)

export default component.exports